import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { Box, Button, List, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ArrowRight } from "lucide-react";
import type React from "react";
import { SortableItem } from "./SortableItem";

const ColumnBox = styled(Box)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    minHeight: 400,
    display: "flex",
    flexDirection: "column",
}));

const SearchContainer = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

const ColumnTitle = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    fontWeight: 500,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
}));

const ScrollableList = styled(List)({
    flex: 1,
    overflowY: "auto",
});

interface AvailableField {
    key: string;
    label: string;
}

interface AvailableFieldsProps {
    fields: AvailableField[];
    searchTerm: string;
    onSearchChange: (value: string) => void;
    onQuickAdd: (fieldKey: string) => void;
    onAddAll: () => void;
}

const AvailableFields: React.FC<AvailableFieldsProps> = ({
    fields,
    searchTerm,
    onSearchChange,
    onQuickAdd,
    onAddAll,
}) => {
    return (
        <ColumnBox>
            <ColumnTitle variant="h6">
                Available Fields
                <Button
                    size="small"
                    onClick={onAddAll}
                    disabled={fields.length === 0}
                    endIcon={<ArrowRight size={16} />}
                >
                    Add All
                </Button>
            </ColumnTitle>
            <SearchContainer>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Search fields..."
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
            </SearchContainer>
            <ScrollableList>
                <SortableContext
                    items={fields.map((f) => f.key)}
                    strategy={verticalListSortingStrategy}
                    id="available"
                >
                    {fields.map((field) => (
                        <SortableItem
                            key={field.key}
                            id={field.key}
                            onQuickAdd={() => onQuickAdd(field.key)}
                            showAddButton={true}
                        >
                            {field.label}
                        </SortableItem>
                    ))}
                </SortableContext>
            </ScrollableList>
        </ColumnBox>
    );
};

export default AvailableFields;
